import React from 'react';

const ClientServerErrorPage = () => {
    return (
        <div>
            ERROR
        </div>
    );
};

export default ClientServerErrorPage;
